<template>
  <v-card>
    <v-card-title>
      Uživatelé
    </v-card-title>
    <v-col>
      <v-row cols="12" sm="3">
      <v-col>
        <v-select
          v-model="selectedUserType"
          clearable
          label="Typ účtu"
          :items="['Zákazník', 'Poskytovateľ', 'ADMIN']"
          multiple
          filled
          dense
          outlined
          auto-grow
        />
      </v-col> 
      <v-col>
        <v-text-field
          v-model="name"
          clearable
          label="Jméno"
          outlined
          filled
          dense
        />
      </v-col>
      <v-col>
        <v-text-field
          v-model="phone"
          clearable
          label="Telefon"
          outlined
          filled
          dense
        />
      </v-col>
      </v-row>
    </v-col>
    <v-card-actions>
      <v-btn small color="secondary" v-if="selectedUser.length===1 && selectedUser[0].roles && !selectedUser[0].roles.poziarnik && selectedUser[0].roles.provider" outlined @click="checkUser" :disabled="selectedUser.length === 0">{{selectedUser[0].meta.active ? "Neaktivní" : "Aktivní"}}</v-btn>
      <v-btn small color="secondary" v-if="selectedUser.length===1 && selectedUser[0].roles && !selectedUser[0].roles.poziarnik && !selectedUser[0].roles.provider && selectedUser[0].roles.user" outlined @click="blockUser" :disabled="selectedUser.length === 0">{{selectedUser[0].meta.blocked ? "Rozblokovat" : "Zablokovat"}}</v-btn>
    </v-card-actions>
    <v-data-table class="yzz-table"
                  dense
                  :headers="headers"
                  :items="items"
                  :server-items-length="itemsLength"
                  :options.sync="options"
                  :footer-props="footerProps"
                  multi-sort
                  mobile-breakpoint="-1"
                  show-select
                  single-select
                  v-model="selectedUser"
                  @click:row="openUser"
                  item-key="_id"
    >
      <template #item.isProvider="{ item }">
        {{item.roles && item.roles.poziarnik ? "ADMIN" : item.roles && item.roles.provider ? "Poskytovateľ" : "Zákazník"}}
      </template>
      <template #item.meta.active="{ item }">
        <div :class="[{active :item.meta && item.meta.active},{inactive :item.meta && !item.meta.active}]">
          {{item.meta && item.meta.active ? "Aktivní" : "Neaktivní"}}
        </div>
      </template>
      <template #item.fullName="{ item }">
        {{ formatFullName(item)}}
      </template>
      <template #item.birth="{ item }">
        {{ formatBirth(item) }}
      </template>
      <template #item.createdAt="{ item }">
        {{ formatCreatedAt(item) }}
      </template>
      <template #item.updatedAt="{ item }">
        {{ formatUpdatedAt(item) }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import {formatDate, formatDatetime} from '@/helper/date-helper'
import {exportCSVFile, generateRequestParams} from '@/helper/global-helper'

export default {
  name: "UsersTable",
  data() {
    return {
      headers: [
        {text: 'Typ úctu', value: 'isProvider', sortable: false},
        {text: 'Stav', value: 'meta.active', sortable: false},
        {text: 'Jméno', value: 'fullName', sortable: false},
        {text: 'Email', value: 'email', sortable: false},
        {text: 'Phone number', value: 'phoneNumber', sortable: false},
        {text: 'IČO', value: 'cin', sortable: false},
        {text: 'DIČ', value: 'dic', sortable: false},
        {text: 'Vytvořeno', value: 'createdAt'},
      ],
      options: {
        itemsPerPage: 15
      },
      footerProps: {
        itemsPerPageOptions: [15, 25, 50]
      },
      data: null,
      search: null,
      selectedUser: [],
      selectedUserType: [],
      name: "",
      phone: ""
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    itemsLength() {
      if (!this.data) return 0
      return this.data.total
    },
    items() {
      if (!this.data) return []
      return this.data.data
    }
  },
  methods: {
    getData() {
      let params= generateRequestParams(
          this.options.itemsPerPage * (this.options.page - 1),
              this.options.itemsPerPage,
              null,
          this.options.sortDesc[this.options.sortBy.indexOf("createdAt")] ? "asc" : "desc"
      )

      if (this.selectedUserType) {
        this.selectedUserType.forEach((type) => {
          params.append("roles", type);
        });
      }

      if (this.name) {
        params.append("name", this.name)
      }

      if (this.phone) {
        params.append("phone", this.phone)
      }

      this.axios.get('v1/users', {
        params
      })
        .then(({data}) => {
          this.data = data
        })
    },
    checkUser(){
      const userId = this.selectedUser[0]._id

      this.axios.put('/v1/users/' + userId + '/activate',{
        "active": !this.selectedUser[0].meta.active
      }).then(()=>{
        this.selectedUser[0].meta.active = !this.selectedUser[0].meta.active
        this.$store.commit('addAlert', {
          type: 'success',
          message: "Úspěšně"
        })
      })
          .catch((el) => {
            if (el.response && el.response.data && el.response.data.errors) {
              el.response.data.errors.forEach((error) => {
                this.$store.commit('addAlert', {
                  type: 'error',
                  message: error.message
                })
              })
            } else {
              this.$store.commit('addAlert', {
                type: 'error',
                message: "Chyba"
              })
            }
          })
          .finally(() => {
          })
    },
    blockUser(){
      const userId = this.selectedUser[0]._id
      this.axios.put('/v1/users/' + userId + '/block',{
        "block": !this.selectedUser[0].meta.blocked
      }).then(({data}) => {
        this.selectedUser[0].meta.blocked = !this.selectedUser[0].meta.blocked
        this.$store.commit('addAlert', {
          type: 'success',
          message: "Úspěšně"
        })
      })
        .catch((el) => {
          if (el.response && el.response.data && el.response.data.errors) {
            el.response.data.errors.forEach((error) => {
              this.$store.commit('addAlert', {
                type: 'error',
                message: error.message
              })
            })
          } else {
            this.$store.commit('addAlert', {
              type: 'error',
              message: "Chyba"
            })
          }
        })
        .finally(() => {
        })
    },
    openUser({ _id }) {
      this.$router.push('/app/users/' + _id)
    },
    formatBirth({ birth }) {
      return formatDate(birth)
    },
    formatCreatedAt({ createdAt }) {
      return formatDatetime(createdAt)
    },
    formatUpdatedAt({ updatedAt }) {
      return formatDatetime(updatedAt)
    },
    formatFullName(item) {
      return item?.roles?.provider ? item?.businessName : item?.name + ' ' + item?.surname
    },
    exportCsv(){
      exportCSVFile(this.headers, this.items, 'users')
    }
  },
  watch: {
    selectedUserType: {
      handler() {
        this.getData()
      },
      deep: true,
    },
    name: {
      handler() {
        this.getData()
      },
      deep: true,
    },
    phone: {
      handler() {
        this.getData()
      },
      deep: true,
    },
    options: {
      handler() {
        this.getData()
      },
      deep: true,
    }
  }
}
</script>

<style scoped>
.active{
  color: green;
}
.inactive{
  color: red;
}
</style>